import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './config/AppRoutes'
import { store } from './store/store.js'

Vue.use(VueRouter)

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes,
	store
});

function isLoggedIn() {
	return localStorage.getItem("auth");
}
/*
function role() {
	return localStorage.getItem("auth");
}*/

router.beforeEach((to, from, next) => {
	
	//console.log('if elott getroleid',router.app.$store.getters.roleId);
	
	if(to.path.substring(0,4) == '/api'){
		to.path = to.path.substring(4);
	}

	if (to.matched.some(record => record.meta.authOnly)) {
		if (!isLoggedIn()) {
			next({
				path: "/login",
				query: { redirect: to.fullPath }
			});
		} else {
			if(to.meta.role == 'admin' && ![1,2,3].includes(router.app.$store.getters.roleId)){
				next({
					path: "/booking",
					query: { redirect: to.fullPath }
				});
			}else{
				next();
			}
		}
	} else if (to.matched.some(record => record.meta.guestOnly)) {
		if (isLoggedIn()) {
			//ÉS IDE
			next({
				path: "/booking",
				query: { redirect: to.fullPath }
			});
		} else {
			next();
		}
	} else {
		if([1,2,3].includes(router.app.$store.getters.roleId)){
			next({
				path: "/under-construction-admin", 
				query: { redirect: to.fullPath }
			});
		}else{
			console.log('ifbengetroleid',router.app.$store.getters.roleId)
			next({
				path: "/under-construction",
				query: { redirect: to.fullPath }
			});
		}
	}
});

export default router;
